import { IInitialUserState } from 'interfaces/user.interface';

const initialUserState: IInitialUserState = {
  dbUser: null,
  isLoading: true,
  updateUser: () => Promise.resolve(false),
  updateUserAvatar: () => Promise.resolve(false),
  updateLanguage: () => Promise.resolve(false),
  selectUserSuperAdmin: () => {},
};

export default initialUserState;
